module.exports = __webpack_public_path__ + "img/dialog-pic.58c6e219.png";